"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SIZES = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _communication = require("../../../../../../icons-react/communication");
var _excluded = ["size"];
var SIZES = exports.SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var skeletonIcon = function skeletonIcon(size) {
  switch (size) {
    case SIZES.SMALL:
      return /*#__PURE__*/_react["default"].createElement(_communication.SkeletonSmall, {
        width: 228,
        height: 36
      });
    case SIZES.MEDIUM:
      return /*#__PURE__*/_react["default"].createElement(_communication.SkeletonMedium, {
        width: 228,
        height: 49
      });
    case SIZES.LARGE:
      return /*#__PURE__*/_react["default"].createElement(_communication.SkeletonLarge, {
        width: 228,
        height: 84
      });
    default:
      return null;
  }
};
var LogSkeleton = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var size = _ref.size,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledItem, props, skeletonIcon(size));
});
LogSkeleton.displayName = 'LogSkeleton';
LogSkeleton.propTypes = {
  className: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(Object.values(SIZES))
};
LogSkeleton.defaultProps = {
  className: '',
  size: SIZES.MEDIUM
};
var StyledItem = _styledComponents["default"].div.withConfig({
  displayName: "LogSkeleton__StyledItem",
  componentId: "sc-id50t3-0"
})(["padding-bottom:10px;> *{animation:fade 0.1s ease;@keyframes fade{from{opacity:0;}}}"]);
var _default = exports["default"] = LogSkeleton;